import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {PoslovniUgovorDocument} from "./PoslovniUgovorDocument";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {AneksUgovoraDocument} from "./AneksUgovoraDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, tip ugovora, partner, sektor
// opciono: opis, lista priloga

export const aneksUgovoraDocumentFields: IntercateKeysMap<AneksUgovoraDocument, EntityField<AneksUgovoraDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	contractType: {
		name: "contractType", dataType: EntityFieldDataType._string, label: "Tip ugovora",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<AneksUgovoraDocument>> = [
	aneksUgovoraDocumentFields.indexingNumber,
	aneksUgovoraDocumentFields.indexingDate,
	aneksUgovoraDocumentFields.documentNumber,
	aneksUgovoraDocumentFields.documentDate,
	aneksUgovoraDocumentFields.assignedTo,
	aneksUgovoraDocumentFields.clientId,
	aneksUgovoraDocumentFields.sectorId,
	aneksUgovoraDocumentFields.contractType,
	aneksUgovoraDocumentFields.tags,
	aneksUgovoraDocumentFields.description,
	aneksUgovoraDocumentFields.parentId
]

export const aneksUgovoraDocumentFieldsDescriptor: EntityFieldsDescriptor<AneksUgovoraDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
